import { css } from '@linaria/core';
import { baseTheme, breakpoints, theming } from 'styles/utils';
export const container = "omponents__Pricing__styles_tsx-container-c1e9hldc";
export const chipWithCustomPopover = "omponents__Pricing__styles_tsx-chipWithCustomPopover-cpjusp";
export const popoverStyle = "omponents__Pricing__styles_tsx-popoverStyle-p5ly2w3";
export const descriptionLinkStyled = "omponents__Pricing__styles_tsx-descriptionLinkStyled-dmjqbeq";
export const workflowPricingPopover = "omponents__Pricing__styles_tsx-workflowPricingPopover-w1qbrcd9";
export const pricingTableStyle = "omponents__Pricing__styles_tsx-pricingTableStyle-p6bi8m1";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.tsx");